export const UPDATE_PAGE_COUNT = 'UPDATE_PAGE_COUNT'
export const UPDATE_PAGE_NUM = 'UPDATE_PAGE_NUM'
export const UPDATE_PAGE_SIZE = 'UPDATE_PAGE_SIZE'
export const RESET_PAGINATION = 'RESET_PAGINATION'
